import axios from 'axios';

// URL DO NOVO WEBHOOK DE LOGIN (ID: b870535e...)
const LOGIN_API_URL = 'https://zapshop.app/api/auth/login';
const AUTH_KEY = 'zapshop_auth';

export interface AuthUser {
  tenant_id: string;
  name?: string;
  email: string;
  token?: string;
  role?: 'SUPER_ADMIN' | 'TENANT_ADMIN';
  terms_accepted?: boolean; // Adicionado
}

export const login = async (email: string, pass: string): Promise<AuthUser> => {
  try {
    console.log("Iniciando login real em:", LOGIN_API_URL);

    // Envia 'password' pois é isso que o Postgres no n8n espera
    const res = await axios.post(LOGIN_API_URL, {
      email,
      password: pass
    });

    // O servidor retorna { status: 200, tenant_id: "...", email: "...", terms_accepted: boolean }
    const data = res.data;

    if (data.tenant_id) {
      const user: AuthUser = {
        tenant_id: data.tenant_id,
        email: data.email,
        name: data.name || 'Admin',
        role: data.user?.role || 'TENANT_ADMIN',
        token: data.token,
        terms_accepted: data.terms_accepted || false // Captura do backend
      };

      // Salva a sessão no navegador
      localStorage.setItem(AUTH_KEY, JSON.stringify(user));
      return user;
    }

    throw new Error("Resposta inválida do servidor: Tenant ID não encontrado.");

  } catch (error) {
    console.error("Erro CRÍTICO no login:", error);
    throw error; // Lança o erro real para a tela mostrar "Credenciais Inválidas"
  }
};

export const logout = () => {
  localStorage.removeItem(AUTH_KEY);
  window.location.href = '/login';
};

export const getAuth = (): AuthUser | null => {
  const stored = localStorage.getItem(AUTH_KEY);
  return stored ? JSON.parse(stored) : null;
};

export const isAuthenticated = (): boolean => {
  return !!localStorage.getItem(AUTH_KEY);
};
